<template>
    <el-dialog title="批量重置密码" :visible="isShow" :before-close="handleClose" width="30%">
        <el-form :model="form" ref="form" :rules="rules">
            <div style="margin-top: 2px">
                <el-radio-group v-model="mod" size="small">
                    <el-radio-button label="BATCH_SET">统一设置密码</el-radio-button>
                    <el-radio-button label="SMS_RANDOM">短信随机密码</el-radio-button>
                </el-radio-group>
            </div>

            <div style="margin-top: 20px" v-if="mod=='BATCH_SET'">
                <el-form-item prop="type" label="选择账号">
                    <el-radio-group v-model="form.pwd_set_type" size="small">
                        <el-radio :label="1">已勾选账号</el-radio>
                        <el-radio :label="2">全部账号</el-radio>
                    </el-radio-group>
                </el-form-item>
            </div>




            <p style="color: #F56C6C"></p>
            <el-alert v-if="mod=='BATCH_SET' && form.pwd_set_type == 1" :title="'该操作将给当前选中的 ' + accounts.length + ' 个账号统一设置一个新的密码'" type="warning" show-icon></el-alert>
            <el-alert v-if="mod=='BATCH_SET' && form.pwd_set_type == 2" :title="'警告：该操作将给当前客户的所有账号统一设置一个新的密码, 该操作存在较高风险，请谨慎操作!'" type="error" show-icon></el-alert>
            <el-alert v-if="mod=='SMS_RANDOM'" title="使用须知" :description="'该操作将给当前选中的 ' + accounts.length + ' 个账号每个都随机产生一个新的密码，并以短信形式发送给账号绑定的手机号码，对于未绑定手机的账号，系统会自动将其过滤'" type="warning" show-icon></el-alert>
            <el-form-item v-if="mod=='BATCH_SET'" prop="password" label="新密码">
                <el-input type="password" v-model="form.password" :show-password="true" placeholder="请输入要设置的密码"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button v-if="mod=='BATCH_SET'" :loading="submiting" type="primary" @click="save">保存密码</el-button>
            <el-button v-if="mod=='SMS_RANDOM'" :loading="submiting" type="primary" @click="send">发送密码</el-button>
        </div>
    </el-dialog>
</template>

<script>

    import AccountService from "~/services/CustomerAccounts";
    import encrypt from "~/common/encrypt";

    const MOD_BATCH_SET = 'BATCH_SET'; //
    const MOD_SMS_RANDOM = 'SMS_RANDOM';

    export default {
        name: "BatchSetPwd",
        props: {
            customerId: {
                type: Number,
                default: 0,
                required: true
            },
            accounts: {
                type: Array,
                default: [],
                required: true
            },
            display: {
                type: Boolean,
                default: false,
                required: true
            },
        },
        data() {
            return {
                isShow: false,
                mod: MOD_BATCH_SET,
                details: [],
                submiting: false,
                form: {
                    pwd_set_type: 1,
                    customer_id: 0,
                    accounts: [],
                    password: ''
                },
                rules: {
                    password: [
                        {required: true, message: "密码不允许为空", trigger: "blur"},
                        {min: 6, max: 20, message: "密码长度最小6位最大不超过20位"}
                    ]
                }
            }
        },
        created() {
            this.isShow = this.display;
            if (this.accounts.length > 0) {
                this.form.accounts = this.accounts;
                this.form.customer_id = this.customerId;
            }
        },

        methods: {

            close(status = false) {
                this.isShow = false;
                this.$emit("callback", status);
            },

            handleClose() {
                this.$confirm("确认要关闭窗口？", "温馨提示", {type: "warning"}).then(ok => {
                    this.close();
                }).catch(cancel => {
                    return false;
                });
            },

            /**
             * 保存手工设置密码
             */
            save() {
                this.$refs["form"].validate(valid => {
                    if (valid) {

                        if (this.form.pwd_set_type && this.form.pwd_set_type == 2) {
                            this.$confirm("您当前执行的操作存在一定风险，您已经充分了解该风险并要继续执行该操作嘛?", "温馨提示", {
                                type: "warning",
                                confirmButtonText: '是的,我要继续',
                                cancelButtonText: '等等,我再想想'
                            }).then(ok => {
                                this.submiting = true;
                                AccountService.batchResetPassword({
                                    pwd_set_type: this.form.pwd_set_type,
                                    customer_id: this.form.customer_id,
                                    accounts: this.form.accounts,
                                    password: encrypt.encode(this.form.password)
                                }).then(res => {
                                    this.submiting = false;
                                    if (res.code == 0) {
                                        this.$message({
                                            message: "批量重置成功!",
                                            type: "success",
                                            showClose: true,
                                        });
                                        this.close(true);
                                    }
                                }).catch(error => {
                                    console.error(error);
                                    this.submiting = false;
                                })
                            }).catch(cancel => {
                                return false;
                            });
                            return;
                        }

                        this.submiting = true;
                        AccountService.batchResetPassword({
                            pwd_set_type: this.form.pwd_set_type,
                            customer_id: this.form.customer_id,
                            accounts: this.form.accounts,
                            password: encrypt.encode(this.form.password)
                        }).then(res => {
                            this.submiting = false;
                            if (res.code == 0) {
                                this.$message({
                                    message: "批量重置成功!",
                                    type: "success",
                                    showClose: true,
                                });
                                this.close(true);
                            }
                        }).catch(error => {
                            console.error(error);
                            this.submiting = false;
                        })
                    }
                })
            },

            /**
             * 短信发送随机密码
             */
            send() {
                this.$confirm("该操作将重置选定的所有账号的密码，且只对绑定有手机账号生效，确定继续嘛？", "温馨提示", {type: "warning"}).then(ok => {
                    this.submiting = true;
                    AccountService.setRandomPassword(this.form).then(res => {
                        this.submiting = false;
                        if (res.code == 0) {
                            this.$message({
                                message: "执行成功，密码已通过短信发送.",
                                type: "success",
                                showClose: true,
                            });
                            this.close(true);
                        }
                    });
                }).catch(cancel => {
                    console.error(error);
                    this.submiting = false;
                    return false;
                });
            }

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/customer/dialog/BatchSetPwd.vue